module.exports = __webpack_public_path__ + "img/team-banner@3x.9b804b2f.png";